const versionWeb = '1.2'
export default versionWeb;